// ponytail: single source of truth for tag/facet label i18n.
// Filtering matches on the original (zh) tag strings stored on projects;
// this map only localizes DISPLAY. Facet labels resolve through here too,
// since every facet.label is itself a tag string.
export default {
	'LLM': { zh: 'LLM', en: 'LLM' },
	'VRChat': { zh: 'VRChat', en: 'VRChat' },
	'UE5': { zh: 'UE5', en: 'UE5' },
	'C++': { zh: 'C++', en: 'C++' },
	'Unity': { zh: 'Unity', en: 'Unity' },
	'Game Jam': { zh: 'Game Jam', en: 'Game Jam' },
	'高考': { zh: '高考', en: 'Gaokao' },
	'自用工具': { zh: '自用工具', en: 'Personal Tool' },
	'弹幕互动': { zh: '弹幕互动', en: 'Danmaku' },
	'AI动画': { zh: 'AI动画', en: 'AI Animation' },
	'开源': { zh: '开源', en: 'Open Source' },
	'联机': { zh: '联机', en: 'Multiplayer' },
	'网络联机': { zh: '网络联机', en: 'Multiplayer' },
	'不止于纸上': { zh: '不止于纸上', en: 'Beyond Books' },
	'星辉落': { zh: '星辉落', en: 'Starfall' },
	'视觉小说': { zh: '视觉小说', en: 'Visual Novel' },
	'小说': { zh: '小说', en: 'Novel' },
	'纪实': { zh: '纪实', en: 'Documentary' },
	'课程作业': { zh: '课程作业', en: 'Coursework' },
	'独立游戏': { zh: '独立游戏', en: 'Indie Game' },
	'星铭世界': { zh: '星铭世界', en: 'Xingming World' },
	'心界': { zh: '心界', en: 'Heart World' },
	'世界观': { zh: '世界观', en: 'Worldview' },
	'世界观核心': { zh: '世界观核心', en: 'Worldview Core' },
	'AI大世界范式Ⅰ': { zh: 'AI大世界范式Ⅰ', en: 'AI Grand World Paradigm I' },
	'AI大世界范式Ⅱ': { zh: 'AI大世界范式Ⅱ', en: 'AI Grand World Paradigm II' },
	'AI大世界尝试': { zh: 'AI大世界尝试', en: 'AI Grand World Experiment' }
}
